import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Får en vingård sälja vin via nätet under gårdsförsäljningsreglerna?";
const SHORT_ANSWER = "Nej. Gårdsförsäljning är fysisk försäljning vid besök på anläggningen. Internetförsäljning omfattas inte.";

export const Route = createFileRoute("/fraga/far-vingard-salja-via-natet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Får en vingård sälja vin via nätet under gårdsf…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"För distansförsäljning gäller fortfarande Systembolagets monopol och EU-rättens regler om gränsöverskridande handel."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning/vingard", label: "Gårdsförsäljning – vingård" }}
      related={[{"to": "/fraga/vilka-volymregler-galler-for-mikrobryggeri", "label": "Vilka volymregler gäller för mikrobryggeri vid gårdsförsäljning?"}, {"to": "/fraga/nar-trader-gardsforsaljning-i-kraft", "label": "När träder gårdsförsäljningen i kraft?"}, {"to": "/fraga/behover-jag-egen-tillverkning", "label": "Måste jag tillverka själv för att få gårdsförsäljning?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Får en vingård sälja vin via nätet under gårdsförsäljning…" },
      { name: "description", content: "Nej. Gårdsförsäljning är fysisk försäljning vid besök på anläggningen. Internetförsäljning omfattas inte." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/far-vingard-salja-via-natet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/far-vingard-salja-via-natet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/far-vingard-salja-via-natet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Får en vingård sälja vin via nätet under gårdsf…", url: "https://alkoholprovet.se/fraga/far-vingard-salja-via-natet" },
      ]),
    ],
  }),
});
